import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const aiApi = createApi({
  reducerPath: 'aiApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'http://localhost:8001/' }),
  endpoints: (builder) => ({
    getAiSuggestions: builder.mutation({
      query: (text) => ({
        url: '/ai/suggest',
        method: 'POST',
        body: { text },
      }),
    }),
  }),
});

export const { useGetAiSuggestionsMutation } = aiApi;
